import React from "react";
import { Card } from "@/components/ui/card";
import { Construction } from "lucide-react";

export default function ComingSoon({ title, description, items = [] }) {
  return (
    <div className="max-w-screen-xl mx-auto p-6 lg:p-8 space-y-6">
      <div>
        <h1 className="font-outfit font-bold text-3xl tracking-tight text-stone-900">{title}</h1>
        <p className="text-sm text-stone-500 mt-1">{description}</p>
      </div>
      <Card className="p-12 border-stone-200 bg-white shadow-sm text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-amber-50 flex items-center justify-center mb-4">
          <Construction className="w-7 h-7 text-amber-600" strokeWidth={1.75} />
        </div>
        <h2 className="font-outfit font-semibold text-xl text-stone-900">Módulo en desarrollo</h2>
        <p className="text-sm text-stone-500 mt-2 max-w-md mx-auto">Este módulo formará parte de la próxima fase. La estructura del sistema ya está lista para incorporarlo.</p>
        {items.length > 0 && (
          <ul className="mt-6 max-w-md mx-auto text-left space-y-2">
            {items.map((it, i) => (
              <li key={i} className="text-sm text-stone-700 flex items-start gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-[#1E3A8A] mt-2 flex-shrink-0" />
                <span>{it}</span>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
